import { defineComponent as _defineComponent } from 'vue'
import { computed, provide, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import { NavBar, ProgressBar } from '@warrenbrasil/nebraska-web';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { BackButton } from '@/modules/common/components/buttons';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import {
  EObjectiveSteps,
  ObjectiveBuilderComponents,
  IFundsData
} from './helpers';

import {
  getPortfolioSheet,
  createPortfolio,
  IPortfolioSheet,
  ICreatePortfolio
} from '@/modules/catalog/services/funds';
import { useCatalogStore } from '@/modules/catalog/store';

interface Props {
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectiveBuilder',
  props: {
    type: null
  },
  setup(__props: any) {

const props = __props as {
  type: string;
};

const router = useRouter();



const isLoading = ref(false);
const portfolioSheet = ref<IPortfolioSheet | null>(null);
const conclusionDetails = ref<ICreatePortfolio | null>(null);
const currentStep = ref(EObjectiveSteps.NAME);
const isQualifiedInvestor = ref(false);
const data = ref<IFundsData>({
  type: props.type,
  objectiveName: '',
  period: {
    formatted: '',
    value: ''
  },
  risk: {
    id: '',
    value: 0,
    formatted: ''
  }
});

const showNavbar = computed(() => {
  return (
    currentStep.value !== EObjectiveSteps.TEMPLATE &&
    currentStep.value !== EObjectiveSteps.CONCLUSION
  );
});

const progress = computed(() => {
  return (currentStep.value + 1) * 0.2;
});

const step = computed(() => {
  return {
    component: ObjectiveBuilderComponents[currentStep.value]
  };
});

function onBack() {
  if (currentStep.value === EObjectiveSteps.NAME) {
    if (useCatalogStore().fromUserFlow) {
      router.push({
        name: useCatalogStore().fromUserFlow,
        query: { cameFrom: useCatalogStore().fromUserCameFrom }
      });
    } else {
      router.push({ name: 'catalog' });
    }

    return;
  }

  if (currentStep.value - 1 === EObjectiveSteps.PROFILE) {
    currentStep.value = isQualifiedInvestor.value
      ? EObjectiveSteps.PROFILE
      : EObjectiveSteps.PERIOD;

    return;
  }

  currentStep.value = currentStep.value - 1;
}

function updateData(
  key: string,
  value: string | number | object,
  askForInvestorType = isQualifiedInvestor.value
) {
  isQualifiedInvestor.value = askForInvestorType;

  if (!askForInvestorType) data.value.profile = undefined;

  data.value = {
    ...data.value,
    [key]: value
  };

  if (currentStep.value + 1 === EObjectiveSteps.PROFILE) {
    currentStep.value = isQualifiedInvestor.value
      ? EObjectiveSteps.PROFILE
      : EObjectiveSteps.RISK;

    return;
  }

  currentStep.value = currentStep.value + 1;
}

async function fetchPortfolioSheet() {
  try {
    isLoading.value = true;

    portfolioSheet.value = await getPortfolioSheet(
      data.value.risk.id,
      props.type,
      data.value.profile?.value
    );

    portfolioSheet.value.header.title = data.value.objectiveName;

    currentStep.value = EObjectiveSteps.TEMPLATE;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações desta carteira. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

async function fetchCreatePortfolio() {
  try {
    isLoading.value = true;

    const params = {
      managedPortfolioId: data.value.risk.id,
      type: props.type,
      name: portfolioSheet.value!.header.title,
      investorType: data.value.profile?.value || 'Common'
    };

    conclusionDetails.value = await createPortfolio(params);

    currentStep.value = EObjectiveSteps.CONCLUSION;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível criar a carteira. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

provide('data', data);
provide('portfolioSheet', portfolioSheet);
provide('isLoading', isLoading);
provide('conclusionDetails', conclusionDetails);

provide('fetchPortfolioSheet', fetchPortfolioSheet);
provide('createPortfolio', fetchCreatePortfolio);
provide('updateData', updateData);
provide('onBack', onBack);

return { __sfc: true,router, props, isLoading, portfolioSheet, conclusionDetails, currentStep, isQualifiedInvestor, data, showNavbar, progress, step, onBack, updateData, fetchPortfolioSheet, fetchCreatePortfolio, NavBar, ProgressBar, FadeTransition, BackButton, NebraskaColors }
}

})